import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import moment from "moment";
import { Modal } from "antd";

import AreaCovered from "../../../components/Dashboard/AreaCovered";
import CropWise from "../../../components/Dashboard/Procurement/CropWise";
import FieldExecutive from "../../../components/Dashboard/FieldExecutive";
import TotalFarmers from "../../../components/Dashboard/Procurement/TotalFarmers";
import TotalFarmSizeProcurement from "../../../components/Dashboard/Procurement/TotalFarmSize";
import InputSales from "../../../components/Dashboard/Procurement/InputSales";
import EstimatedYield from "../../../components/Dashboard/Procurement/EstimatedYield";
import WeatherForecast from "../../../components/Dashboard/Procurement/WeatherForecast";
import TotalHarvest from "../../../components/Dashboard/Procurement/TotalHarvest";
import TotalGrainsPurchased from "../../../components/Dashboard/Procurement/TotalGrainsPurchased";
import ThresherHarvesterQTY from "../../../components/Dashboard/Procurement/ThresherHarvesterQTY";
import DemoCount from "../../../components/Dashboard/AgriPromoter/DemoCount";
import TotalHubSales from "../../../components/Dashboard/AgriPromoter/HubSales";
import FieldVisitCount from "../../../components/Dashboard/AgriPromoter/FieldVisitCount";
import FieldDayIndicatorSales from "../../../components/Dashboard/AgriPromoter/FieldDayIndicatorSales";
import TrainingDetail from "../../../components/Dashboard/AgriPromoter/TrainingDetail";
import TrainingDetailsSales from "../../../components/Dashboard/AgriPromoter/TrainingDetailsSales";
import OverallSales from "../../../components/Dashboard/AgriPromoter/OverAllSales";

const Dashboard = () => {
  const [allowedCharts, setAllowedCharts] = useState([]);

  const cardColors = [
    "linear-gradient(135deg,#92b775,#133215)",
    // "linear-gradient(135deg,#FFD3A5,#FFB75E)", // Orange
    // "linear-gradient(135deg,#A8E6CF,#56C596)", // Green Mint
    // "linear-gradient(135deg,#FFAAAA,#FF8080)", // Soft Red
    // "linear-gradient(135deg,#A1C4FD,#C2E9FB)", // Blue Sky
    // "linear-gradient(135deg,#FEC8D8,#FF9EB5)", // Pink
    // "linear-gradient(135deg,#FFFACD,#FAED27)", // Yellow Soft
    // "linear-gradient(135deg,#B5FFFC,#6DE2E1)", // Aqua
    // "linear-gradient(135deg,#E8E8E8,#CFCFCF)", // Grey
    // "linear-gradient(135deg,#B9F5FF,#6EC6FF)", // Light Blue
  ];

  const chartComponents = [
    { name: "Total Farmers", component: <TotalFarmers /> },
    { name: "Farm Size", component: <TotalFarmSizeProcurement /> },
    { name: "Weather Forecast", component: <WeatherForecast /> },
    { name: "Crop Wise Per Region", component: <CropWise /> },
    { name: "Input Sales", component: <InputSales /> },
    { name: "Estimated Yield", component: <EstimatedYield /> },
    { name: "Total Harvest", component: <TotalHarvest /> },
    { name: "Thresher Harvester Qty", component: <ThresherHarvesterQTY /> },
    { name: "Total Grains Purchased", component: <TotalGrainsPurchased /> },
    { name: "Area Covered Per Ranch", component: <AreaCovered /> },
    { name: "Field Executive Per Region", component: <FieldExecutive /> },
    { name: "Demo Count", component: <DemoCount /> },
    { name: "Hub Sales", component: <TotalHubSales /> },
    { name: "Field Visit Count", component: <FieldVisitCount /> },
    { name: "Field Day Indicator Sales", component: <FieldDayIndicatorSales /> },
    { name: "Training Detail", component: <TrainingDetail /> },
    { name: "Training Detail Sales", component: <TrainingDetailsSales /> },
    { name: "Over All Sales", component: <OverallSales /> },
  ];

  const { sendRequest: getAllowedChartsRequest } = useHttp();

  useEffect(() => {
    const orgId = localStorage.getItem("orgId");
    const useCase = localStorage.getItem("useCase");

    if (orgId && useCase) {
      getAllowedChartsRequest(
        {
          url: `/api/dashboards/?orgId=${orgId}&useCase=${encodeURIComponent(
            useCase
          )}`,
        },
        (res) => {
          const permitted = (res || [])
            .filter((x) => x.status === 1)
            .map((x) => x.chartName);
          setAllowedCharts(permitted);
        }
      );
    }
  }, []);

  const DashboardCard = ({ index, title, children }) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);

    const childWithProps = React.cloneElement(children, {
      isMaximized: false,
      openMaximize: openModal,
    });

    return (
      <>
        <style>
          {`
            @keyframes fadeInUp {
              from { opacity: 0; transform: translateY(20px); }
              to { opacity: 1; transform: translateY(0); }
            }
          `}
        </style>

        <div
          className="card card-primary shadow"
          style={{
            marginBottom: "14px",
            height: "260px",
            overflow: "hidden",
            borderRadius: "12px",
            // background: "linear-gradient(135deg, #ffffff, #f0f4ff)",
            // background: "linear-gradient(135deg, #c8e561ff, #c8ff00ff)",
            background: cardColors[index % cardColors.length],
            boxShadow: "0 6px 18px rgba(0,0,0,0.12)",
            animation: "fadeInUp 0.5s ease",
            transition: "all 0.3s",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-5px)";
            e.currentTarget.style.boxShadow = "0 14px 30px rgba(0,0,0,0.18)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0px)";
            e.currentTarget.style.boxShadow = "0 6px 18px rgba(0,0,0,0.12)";
          }}
        >
          <div
            className="card-header"
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "8px 14px",
              // background: "linear-gradient(90deg,#6a5cff,#4f8bff)",
              // background: "linear-gradient(90deg, rgb(249 227 182), rgb(147 230 142))",
              // color: "white",
              background: "rgba(255,255,255,0.3)",
              backdropFilter: "blur(4px)",
              color: "black",
              fontWeight: "700",
            }}
          >
            <h3
              className="card-title"
              style={{ fontSize: "14px", margin: 0, flex: 1 }}
            >
              {title}
            </h3>

            <button
              type="button"
              className="btn btn-tool"
              onClick={openModal}
              style={{
                fontSize: "18px",
                color: "white",
                border: "none",
                background: "none",
                cursor: "pointer",
                transition: "0.2s",
              }}
              onMouseEnter={(e) => (e.target.style.transform = "scale(1.2)")}
              onMouseLeave={(e) => (e.target.style.transform = "scale(1)")}
            >
              <i className="fas fa-expand"></i>
            </button>
          </div>

          <div style={{ padding: "10px 12px", height: "100%" }}>
            {childWithProps}
          </div>
        </div>

        <Modal
          open={isModalOpen}
          onCancel={closeModal}
          footer={null}
          width={"55vw"}
          centered
          styles={{
            body: {
              padding: 0,
              height: "70vh",
              background: "transparent",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            },
          }}
        >
          <div
            style={{
              width: "100%",
              height: "70vh",
              padding: "10px",
              background: "white",
              borderRadius: "10px",
              boxShadow: "0 6px 20px rgba(0,0,0,0.15)",
            }}
          >
            {React.cloneElement(children, { isMaximized: true })}
          </div>
        </Modal>
      </>
    );
  };

  return (
    <div className="content-wrapper">
      <div
        className="row mx-2"
        style={{
          marginTop: "15px",
          marginBottom: "20px",
          textAlign: "center",
        }}
      >
        <div className="col-12">
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "6px",
            }}
          >
            <h2
              style={{
                margin: 0,
                fontWeight: "700",
                letterSpacing: "1px",
                color: "#222",
              }}
            >
              DASHBOARD
            </h2>
          </div>
        </div>
      </div>

      <section className="content">
        <div className="container-fluid">
          <div className="row">
            {chartComponents.map((chart, index) =>
              allowedCharts.includes(chart.name) ? (
                <div className="col-md-4 col-sm-6" key={index}>
                  <DashboardCard title={chart.name} index={index}>
                    {chart.component}
                  </DashboardCard>
                </div>
              ) : null
            )}

            {/* {allowedCharts.includes("Total Farmers") && (
              <div className="col-md-4 col-sm-6">
                <DashboardCard title="Total Farmers">
                  <TotalFarmers />
                </DashboardCard>
              </div>
            )}

            {allowedCharts.includes("Farm Size") && (
              <div className="col-md-4 col-sm-6">
                <DashboardCard title="Farm Size">
                  <TotalFarmSizeProcurement />
                </DashboardCard>
              </div>
            )}

            {allowedCharts.includes("Weather Forecast") && (
              <div className="col-md-4 col-sm-6">
                <DashboardCard title="Weather Forecast">
                  <WeatherForecast />
                </DashboardCard>
              </div>
            )}

            {allowedCharts.includes("Crop Wise Per Region") && (
              <div className="col-md-4 col-sm-6">
                <DashboardCard title="Crop Wise Per Region">
                  <CropWise />
                </DashboardCard>
              </div>
            )}

            {allowedCharts.includes("Input Sales") && (
              <div className="col-md-4 col-sm-6">
                <DashboardCard title="Input Sales">
                  <InputSales />
                </DashboardCard>
              </div>
            )}

            {allowedCharts.includes("Estimated Yield") && (
              <div className="col-md-4 col-sm-6">
                <DashboardCard title="Estimated Yield">
                  <EstimatedYield />
                </DashboardCard>
              </div>
            )}

            {allowedCharts.includes("Total Harvest") && (
              <div className="col-md-4 col-sm-6">
                <DashboardCard title="Total Harvest">
                  <TotalHarvest />
                </DashboardCard>
              </div>
            )}
            
            {allowedCharts.includes("Thresher Harvester Qty") && (
              <div className="col-md-4 col-sm-6">
                <DashboardCard title="Thresher Harvester Qty">
                  <ThresherHarvesterQTY />
                </DashboardCard>
              </div>
            )}

            {allowedCharts.includes("Total Grains Purchased") && (
              <div className="col-md-4 col-sm-6">
                <DashboardCard title="Total Grains Purchased">
                  <TotalGrainsPurchased />
                </DashboardCard>
              </div>
            )}

            {allowedCharts.includes("Area Covered Per Ranch") && (
              <div className="col-md-4 col-sm-6">
                <DashboardCard title="Area Covered Per Ranch">
                  <AreaCovered />
                </DashboardCard>
              </div>
            )}

            {allowedCharts.includes("Field Executive Per Region") && (
              <div className="col-md-4 col-sm-6">
                <DashboardCard title="Field Executive Per Region">
                  <FieldExecutive />
                </DashboardCard>
              </div>
            )} */}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Dashboard;
